import React from "react";
import { Box, useMediaQuery } from "@mui/material";
import LeftSideGridItem from "./LeftSideGridItem";
import { spliter } from "../../../../../Utils/Spliter";

export default function LeftSide({ slides }) {
  const isMobile = useMediaQuery("(max-width:600px)");

  const getImageData = (index) => {
    const targetImage = isMobile
      ? slides?.[index]?.image_mobile
      : slides?.[index]?.image_desktop;

    return {
      url: targetImage?.file_name
        ? import.meta.env?.VITE_URL + targetImage?.file_name
        : "",
      alt: targetImage?.alt || "banner image",
    };
  };

  // Grid layout configuration mapped dynamically
  const gridConfig = [
    { id: 1, col: "1 / 3", row: "1 / 3", limit: 200, mobileLimit: 150 },
    { id: 2, col: "3", row: "1" },
    { id: 3, col: "4", row: "1" },
    { id: 4, col: "3 / 5", row: "2" },
    { id: 5, col: "1 / 5", row: "3 / 5", limit: 300, mobileLimit: 150 },
  ];

  const renderedGridItems = gridConfig?.map((config) => {
    const slideData = slides?.[config?.id];
    if (!slideData) return null;

    const { url, alt } = getImageData(config?.id);

    return (
      <LeftSideGridItem
        key={config?.id}
        link={slideData?.back_link}
        image={url}
        alt={alt}
        seo_title={slideData?.seo_title}
        btnText="مشاهده"
        text={
          config?.limit
            ? spliter({
                text: slideData?.desc,
                limit: config?.limit,
                mobileLimit: config?.mobileLimit,
              })
            : null
        }
        sx={{ gridColumn: config?.col, gridRow: config?.row }}
      />
    );
  });

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "grid",
        gridTemplateColumns: "repeat(4, 1fr)",
        gridTemplateRows: "repeat(4, 1fr)",
        gap: {xs:".7rem" , xl:"1rem"},
      }}
    >
      {renderedGridItems}
    </Box>
  );
}
